import { HookNavGet } from 'Hook'
import { TypeEntityLinkTo, TypeNavHttpControl } from 'Type'

const HookNavGetCount = (linkTo :string | TypeEntityLinkTo | undefined) :number | undefined => {
    const countControl :TypeNavHttpControl<any> = HookNavGet({linkTo, paramUpdates: [{ type: 'size', values: ['0']}]})
    return countControl.res?.data?.data.page?.totalElements
}

export default HookNavGetCount